import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { Button } from '../Button';
import reviewStyles from './writeReview-tw-styles';

class ThankYouModal extends React.Component {
  static propTypes = {
    form: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.shape({
        fields: PropTypes.object,
      }),
    ]).isRequired,
    onCancel: PropTypes.func,
    url: PropTypes.string,
  };

  static defaultProps = {
    onCancel: () => null,
    url: '',
  };

  render() {
    let { form, onCancel, url } = this.props;
    let formData = form && form.fields;
    const i18nMessages = require(`../../../constants/messages/pt-BR`);
    let closeClick = () => {
      let thankyouVal = formData && formData.thankyou;
      thankyouVal.value = false;
      onCancel();
    };

    return formData.thankyou.value ? (
      <div className={classNames(reviewStyles.sorryThanks.modalWrapper)}>
        <div className={classNames(reviewStyles.sorryThanks.modalBG)}>
          <div className={classNames(reviewStyles.sorryThanks.modalTitle)}>
            <span className={classNames(reviewStyles.sorryThanks.modalHeader)}>
              {
                <FormattedMessage
                  id={i18nMessages.reviewThankYou}
                  defaultMessage={i18nMessages.reviewThankYou}
                />
              }
            </span>
            {/* <Button
              className={classNames(reviewStyles.sorryThanks.modalClose)}
              onClick={closeClick}
            >
              <span className={classNames(reviewStyles.sorryThanks.closeIcon)}>
                {`×`}
              </span>
            </Button> */}
          </div>

          <div className={classNames(reviewStyles.sorryThanks.dialogWrapper)}>
            <p className={classNames(reviewStyles.sorryThanks.dialogContent)}>
              {
                <FormattedMessage
                  id={i18nMessages.reviewThankContent}
                  defaultMessage={i18nMessages.reviewThankContent}
                />
              }
            </p>
            <div className={classNames(reviewStyles.sorryThanks.buttonWrapper)}>
              <Button
                data-pgaction-redirection="0"
                to={url}
                className={classNames(reviewStyles.sorryThanks.buttonClass)}
                onClick={closeClick}
              >
                {
                  <FormattedMessage
                    id={i18nMessages.reviewContinueButton}
                    defaultMessage={i18nMessages.reviewContinueButton}
                  />
                }
              </Button>
            </div>
          </div>
        </div>
      </div>
    ) : (
      ''
    );
  }
}

export default observer(ThankYouModal);
